import DropdownSelect from '../../ui-kit/components/atoms/DropdownSelect'
import DropdownItem from '../../ui-kit/components/atoms/items/DropdownItem'
import {useState} from 'react'
import PDF from '../../static/sample.pdf'
import {Document, Page} from 'react-pdf/dist/umd/entry.webpack'
import React from 'react'
import DropdownDocument from '../molecules/DropdownDocument'

const DocumentsSection = () => {
  const [paymentVouchers, setPaymentVouchers] = useState(true)
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({numPages}) {
    setNumPages(numPages)
  }

  return (
    <section className="documents-section n-container no-padding">
      <header className="header">
        <DropdownSelect
          selected={paymentVouchers ? 'Comprobantes de pago' : 'Comprobante de trabajo'}
        >
          <DropdownItem
            onClick={() => setPaymentVouchers(true)}
            isActive={paymentVouchers}
            text="Comprobantes de pago"
          />
          <DropdownItem
            isActive={!paymentVouchers}
            onClick={() => setPaymentVouchers(false)}
            text="Comprobante de trabajo"
          />
        </DropdownSelect>
        <DropdownDocument />
      </header>
      <div className="content">
        <header className="header-content">
          <p className="title-base">
            {paymentVouchers
              ? 'Del 1 al 15 de Agosto del 2022'
              : 'Comprobante de Evelyn Castrejón Jiménez'}
          </p>
          <a href={PDF} download className="button small">
            Descargar
          </a>
        </header>
        <Document file={PDF} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
    </section>
  )
}

export default DocumentsSection
